import NotesModal, { NotesModalFormValues } from '../NotesModal';
import React, { useEffect, useState } from 'react';
import { ApiNote, ApiSortDirection } from '../../api';
import Table from '../../table/Table';
import { fetchNotes, saveNote } from '../amlActions';
import { AppState } from '../../store/store';
import { connect, ResolveThunks } from 'react-redux';
import { setNotesPage } from '../amlReducer';
import Note from '../Note';
import { counterpartyNoteValues, customerNoteValues, NoteOption } from '../amlFiltersReducer';
import { updateFiltersAction } from '../amlFiltersActions';
import { isCounterparty } from '../../common/helper';
import { InternalApiPerson } from '../../api-internal';
import { SalvDropdown, Size } from '@salvapp/ui-components';

interface NoteProps {
  person: InternalApiPerson;
  searchable?: boolean;
}

export const Notes = ({
  fetchNotes,
  saveNote,
  setNotesPage,
  updateNotesFilters,
  person,
  content,
  page,
  size,
  total,
  selectedType,
  searchable = true,
}: Props) => {
  const [fetching, setFetching] = useState(false);
  useEffect(() => {
    fetchNotes(person.id, page, size, selectedType);
  }, [fetchNotes, person.id, page, size, setNotesPage, selectedType]);

  useEffect(() => {
    updateNotesFilters(isCounterparty(person) ? counterpartyNoteValues[0] : customerNoteValues[0]);
  }, [person, updateNotesFilters]);

  const onSubmit = async (values: NotesModalFormValues) => {
    await saveNote(person.id, values);
    await fetchNotes(person.id, page, size, selectedType);
  };

  const fetchByFilter = async (filter: string | undefined) => {
    setFetching(true);
    await fetchNotes(person.id, page, size, selectedType, filter);
    setFetching(false);
  };

  const sortByAttribute = async (attribute: string, direction: ApiSortDirection, filter: string | undefined) => {
    setFetching(true);
    await fetchNotes(person.id, page, size, selectedType, filter, attribute, direction);
    setFetching(false);
  };

  const handleSelectChange = (selected: NoteOption, assignerMethod: any) => {
    assignerMethod(selected);
    setNotesPage(0);
    fetchNotes(person.id, page, size, selected);
  };

  return (
    <Table
      title='Notes'
      total={total}
      page={page}
      size={size}
      items={content}
      fetchPage={setNotesPage}
      actions={() => <NotesModal onSubmit={onSubmit} />}
      filters={() => (
        <SalvDropdown
          ariaLabel={'Note filter'}
          size={Size.SMALL}
          options={isCounterparty(person) ? counterpartyNoteValues : customerNoteValues}
          value={selectedType}
          clearable={false}
          onChange={([value]) => {
            handleSelectChange(value as NoteOption, updateNotesFilters);
          }}
        />
      )}
      onSearch={searchable ? fetchByFilter : undefined}
      onSort={sortByAttribute}
      fetching={fetching}
      body={(content) =>
        content.map((note: ApiNote) => (
          <tr key={note.id}>
            <td>
              <Note note={note} personId={person.id} />
            </td>
          </tr>
        ))
      }
    />
  );
};

const mapStateToProps = ({ aml, amlFilters }: AppState) => {
  return {
    ...aml.notes,
    selectedType: amlFilters.notes,
  };
};

const mapDispatchToProps = {
  fetchNotes,
  saveNote,
  setNotesPage,
  updateNotesFilters: (selected: NoteOption) => updateFiltersAction(selected),
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & NoteProps;

export default connect(mapStateToProps, mapDispatchToProps)(Notes);
